import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'zipCode'
})
export class ZipCodePipe implements PipeTransform {

 
  transform(zipcode: string): string {
    if (!zipcode) {
      return '';
    }

    // Assuming the zipcode is in the format "1234567890"
    const formattedNumber = zipcode.replace(/(\d{5})(\d+)/, '$1-$2');
    return formattedNumber;
  }

}
